'use client';

import { motion } from 'framer-motion';
import type { PageSection } from '@/lib/cms';

export function CmsStatsSection({ section }: { section: PageSection }) {
  const items = section.items ?? [];
  const title = section.title ?? 'By the numbers';
  const description = section.content;

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-bg">
      <div className="max-w-6xl mx-auto">
        {(title || description) && (
          <motion.div
            className="text-center mb-10"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            {title && <h2 className="text-2xl font-bold text-landing-text">{title}</h2>}
            {description && <p className="mt-2 text-landing-muted">{description}</p>}
          </motion.div>
        )}
        <div className="flex flex-wrap justify-center gap-6 sm:gap-10">
          {items.map((item, i) => (
            <motion.div
              key={item.id ?? i}
              className="text-center px-6 py-4 rounded-xl border border-landing-border bg-landing-bg min-w-[140px]"
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
            >
              <p className="text-2xl sm:text-3xl font-bold text-moss">
                {item.title ?? item.subtitle ?? '—'}
              </p>
              <p className="text-sm text-landing-muted mt-1">
                {item.description ?? item.subtitle ?? item.title ?? ''}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
